module.exports = __webpack_public_path__ + "static/img2-30d6a2427ba0fe5f624b2c626b55d6b3.png";